import { render, staticRenderFns } from "./14_ap_tipos_contribucion.vue?vue&type=template&id=5102e89a&scoped=true&"
import script from "./14_ap_tipos_contribucion.vue?vue&type=script&lang=js&"
export * from "./14_ap_tipos_contribucion.vue?vue&type=script&lang=js&"
import style0 from "./14_ap_tipos_contribucion.vue?vue&type=style&index=0&id=5102e89a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5102e89a",
  null
  
)

export default component.exports